export const VALIDATE_QUOTATION_KIT = '/quotation/verify-kit'
